module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./sources/i18n/translations.json
// module id = 1124
// module chunks = 1